import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-372">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-373">
        <div className="bg-white border border-[#e2e8f0] rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px] shadow-sm" data-id="element-374">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180" data-id="element-375" />

          <p className="text-xl md:text-3xl font-medium text-[#0f172a] leading-relaxed mb-6 italic relative z-10" data-id="element-376">
            "Llevaba 3 años sintiendo que trabajaba cada vez más y ahorraba cada
            vez menos. Con el Tomo 1 entendí que mi plata dormía en el banco
            perdiendo valor mientras yo creía que estaba 'guardando'. En el
            primer mes recuperé más de $40.000 que antes se evaporaban sin que
            yo lo viera."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-377">
            <div className="w-10 h-10 bg-[#22c55e] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md" data-id="element-378">
              C
            </div>
            <div className="text-left" data-id="element-379">
              <p className="font-bold text-[#0f172a]" data-id="element-380">Carlos M.</p>
              <p className="text-sm text-[#475569] font-medium" data-id="element-381">
                Empleado administrativo · Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}